import { Themed } from './styles'

export default Themed
